import { g as n } from "../../utils-BOfnFgIH.js";
import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as r, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLivingThing",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m2.125 1.802 1.47.616c.582.245 1.2.228 1.735.138a4.03 4.03 0 0 1 1.34 0c.535.09 1.154.106 1.736-.138l1.37-.574-.298 1.19c-.172.693-.01 1.38.223 1.946a4 4 0 1 1-7.478.2c.153-.437.264-.948.185-1.48l-.283-1.898Zm-.99.147A1 1 0 0 1 2.51.879l1.472.617c.334.14.737.149 1.182.074a5.03 5.03 0 0 1 1.673 0c.445.075.847.067 1.182-.074l1.37-.575h.002a1 1 0 0 1 1.355 1.164l-.297 1.191c-.1.399-.018.85.177 1.323a5 5 0 1 1-9.347.251c.126-.362.186-.697.14-1.003L1.136 1.95ZM3.9 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.4a.5.5 0 0 1-.5-.5Zm3.1 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5a.5.5 0 0 1-.5-.5Zm-2 2a.625.625 0 0 1 .5-1h1c.515 0 .81.588.5 1l-.5.667a.625.625 0 0 1-1 0L5 6.5Zm1 2.333.221.133a2 2 0 0 0 2.058 0l.062-.037a.5.5 0 1 0-.515-.858l-.061.037a1 1 0 0 1-1.03 0l-.413-.248a.625.625 0 0 0-.643 0l-.414.248a1 1 0 0 1-1.03 0l-.061-.037a.5.5 0 0 0-.515.858l.062.037a2 2 0 0 0 2.058 0L6 8.833Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  u
], f = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  p
];
function v(e, I, l, L, b, i) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--living-thing"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Living Thing",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, m, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, f)
    ])
  ], 10, h);
}
const w = /* @__PURE__ */ s(c, [["render", v]]);
export {
  w as default
};
//# sourceMappingURL=living-thing.js.map
